import { HTTP } from '../../http-common'

export default {
  state: {
    loadedLightingSystems: []
  },
  getters: {
    loadedLightingSystems (state) {
      return state.loadedLightingSystems
    }
  },
  mutations: {
    setLoadedLightingSystems (state, payload) {
      state.loadedLightingSystems = payload
    },
    createLightingSystem (state, payload) {
      state.loadedLightingSystems.push(payload)
    },
    updateLightingSystem (state, payload) {
      state.loadedLightingSystems = state.loadedLightingSystems.map(lightingSystem => lightingSystem.id === payload.id ? payload : lightingSystem)
    },
    removeLightingSystem (state, id) {
      state.loadedLightingSystems = state.loadedLightingSystems.filter(lightingSystem => {
        return lightingSystem.id !== id
      })
    },
    clearLoadedLightingSystems (state) {
      state.loadedLightingSystems = []
    }
  },
  actions: {
    loadLightingSystems ({ commit }) {
      commit('clearError')
      commit('setLoading', true)
      commit('setLoadedLightingSystems', [])

      return new Promise((resolve, reject) => {
        HTTP.get('lighting_system_type.json')
          .then(result => {
            console.log(result.data)
            commit('setLoadedLightingSystems', result.data.results)
            resolve(result.data)
          })
          .catch(err => {
            console.log(err)
            commit('setError', err)
            reject(err)
          })
          .finally(() => {
            commit('setLoading', false)
          })
      })
    },
    createLightingSystem ({ commit, getters }, payload) {
      console.log('createLightingSystem')
      commit('clearError')
      commit('setLoading', true)
      const newLightingSystem = {
        description: payload.description
      }
      return new Promise((resolve, reject) => {
        HTTP.post('lighting_system_type.json/', newLightingSystem)
          .then(result => {
            console.log(result)
            commit('createLightingSystem', result.data)
            resolve(result)
          })
          .catch(err => {
            console.log(err)
            commit('setError', err)
            reject(err)
          })
          .finally(() => {
            commit('setLoading', false)
          })
      })
    },
    updateLightingSystem ({ commit, getters }, payload) {
      console.log('updateLightingSystem')
      commit('clearError')
      commit('setLoading', true)
      const lightingSystem = {
        description: payload.description
      }
      return new Promise((resolve, reject) => {
        HTTP.patch(`lighting_system_type.json/${payload.id}/`, lightingSystem)
          .then(result => {
            console.log(result)
            commit('updateLightingSystem', result.data)
            resolve(result)
          })
          .catch(err => {
            console.log(err)
            commit('setError', err)
            reject(err)
          })
          .finally(() => {
            commit('setLoading', false)
          })
      })
    },
    removeLightingSystem ({ commit }, payload) {
      console.log('removeLightingSystem')
      commit('clearError')
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        HTTP.delete(`lighting_system_type.json/${payload}`)
          .then(result => {
            console.log('result', result)
            commit('removeLightingSystem', payload)
            resolve(result)
          })
          .catch(err => {
            console.log(err)
            commit('setError', err)
            reject(err)
          })
          .finally(() => {
            commit('setLoading', false)
          })
      })
    },
    clearLoadedLightingSystems ({ commit }) {
      commit('clearLoadedLightingSystems')
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/lighting_system/index.js